export default "__VITE_ASSET__CWp_9IIc__"